import locations from './locations.json';
import states from './states.json';

export const formatDateTime = (date) => {
    const pad = (num) => (num < 10 ? '0' : '') + num;
    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    const strTime = `${pad(hours)}:${minutes}:${seconds}`;
    return `${year}-${month}-${day} ${strTime}`;
};

export const minToHour = (minutes) => {
    let hours = minutes / 60;
    if (Number.isInteger(hours)) {
        return hours.toString();
    } else {
        return hours.toFixed(2);
    }
}

export const convertMinutesToCustomFormat = (minutes) =>{
    let hours = Math.floor(minutes / 60);
    let remainingMinutes = minutes % 60;
    return remainingMinutes? `${hours}.${remainingMinutes}`  : `${hours}`;
}

export const findStateandCity = (city, countryCode) => {
    const location = locations.find(
      (loc) =>
        loc.name.toLowerCase() === city.toLowerCase() &&
        loc.country.toLowerCase() === countryCode.toLowerCase()
    );
  
    if (location) {
      const stateCode = `${location.country}.${location.admin1}`;
      const stateInfo = states.find((state) => state.code === stateCode);
      if (stateInfo) {
          return `${city}, ${stateInfo.name}`
      } else {
        return city;
      }
    } else {
      return city;
    }
  };